export const THEME_COLORS: Record<string, { main: string; rgb: string }> = {
	blue: { main: '#0d47a1', rgb: '13, 71, 161' },
	azure: { main: '#0288d1', rgb: '2, 136, 209' },
	green: { main: '#1b5e20', rgb: '27, 94, 32' },
	orange: { main: '#ef6c00', rgb: '239, 108, 0' },
	danger: { main: '#e53935', rgb: '229, 57, 53' },
	purple: { main: '#7b1fa2', rgb: '123, 31, 162' },
	rose: { main: '#d81b60', rgb: '216, 27, 96' },
	white: { main: '#90a4ae', rgb: '144, 164, 174' },
	black: { main: '#212121', rgb: '33, 33, 33' },
	red: { main: '#6d1b1b', rgb: '109, 27, 27' },
	yellow: { main: '#ffb300', rgb: '255, 179, 0' },
	km: { main: '#c9a962', rgb: '201, 169, 98' }
};

export const THEME_KEYS = Object.keys(THEME_COLORS) as string[];
